import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import typography from "assets/theme/base/typography";

function Footer() {
  const { size } = typography;

  return (
    <></>
    // <MDBox
    //   width="100%"
    //   display="flex"
    //   flexDirection={{ xs: "column", lg: "row" }}
    //   justifyContent="space-between"
    //   alignItems="center"
    //   px={1.5}
    // >
    //   <MDBox
    //     display="flex"
    //     justifyContent="center"
    //     alignItems="center"
    //     flexWrap="wrap"
    //     color="text"
    //     fontSize={size.sm}
    //     px={1.5}
    //   >
    //
    //
    //     <MDTypography variant="button" fontWeight="small">
    //       ساخته شده با ❤️ در <a href='https://gerafi.com' target='_blank' rel="noopener noreferrer" style={{ color: '#3ecddb', fontWeight: 'bold' }}>گرافی دات کام</a>
    //     </MDTypography>
    //
    //   </MDBox>
    //
    // </MDBox>
  );
}


export default Footer;
